import {Component, EventEmitter, inject, Input, OnDestroy, Output} from '@angular/core';
import {BuilderGeneratedPageSectionI} from "../../../../../../builder-v2.interface";
import {CanvasPageInteractionsService} from "../../../../../../services/canvas-page-interactions.service";
import {tap} from "rxjs/operators";
import {NewBuilderTourEnum} from "../../../../../../builder-tour.enum";
import {CanvasTourService} from "../../../../../../services/canvas-tour.service";

@Component({
    selector: 'db-section-edit-tooltip',
    templateUrl: './section-edit-tooltip.component.html',
    styleUrl: './section-edit-tooltip.component.scss',
    standalone: false
})
export class SectionEditTooltipComponent implements OnDestroy {
  @Input() page: { pageId: number; sectionId: number; section: BuilderGeneratedPageSectionI };

  @Input('sectionType') set sectionType(str: string) {
    this.modifiedSectionType = str?.replace('_', ' ')?.replace(/^./, str[0]?.toUpperCase());
  };

  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  pageInteractionsService: CanvasPageInteractionsService = inject(CanvasPageInteractionsService);
  modifiedSectionType: string;
  loadingFor: string;
  protected readonly newTourEnum = NewBuilderTourEnum;
  tour = {
    title: `Modify the section by editing the prompt`,
    description: `A section description acts as a prompt for the AI to build the corresponding section.`,
  };

  loading$ = this.pageInteractionsService.sectionIsGenerating.pipe(tap((value) => {
    if (!value) {
      this.loadingFor = null;
    }
  }));

  constructor(public canvasTourService: CanvasTourService) {
  }

  onClick($event) {
    $event.stopPropagation();
  }

  removeSection(event: MouseEvent) {
    event.stopPropagation();
    this.close.emit();
    setTimeout(() => {
      this._delete();
    }, 200);
  }

  private _delete() {
    const removeEvent = new KeyboardEvent('keydown', {
      key: 'delete',
      bubbles: true
    });
    document.dispatchEvent(removeEvent);
  }

  onBlur() {
    this.pageInteractionsService.sectionValueChange.next(this.page);
  }

  suggest(type: 'title' | 'description' | 'new' | 'enhance') {
    this.loadingFor = type;
    this.pageInteractionsService.generateSection.next({...this.page, type});
  }

  closeTour() {
    this.canvasTourService.setTour(NewBuilderTourEnum.EDIT_SECTION, true);
  }

  ngOnDestroy() {
    this.closeTour();
  }
}
